import $ from 'jquery/dist/jquery';
import jQuery from 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap.bundle'
import { useNavigate } from "react-router-dom"
import '../Componet';
import { CustomHelper, FixedMessage, RowState } from '../Componet';
import { isNumeric, parseJSON } from 'jquery';
import { toGregorian, toJalaali } from 'jalaali-js'

window.ajaxAnitRepeat = new Array();

const isValidNationalCode = code => {
    if (code.length !== 10 || /(\d)(\1){9}/.test(code)) return false;

    let sum = 0,
        chars = code.split(''),
        lastDigit,
        remainder;

    for (let i = 0; i < 9; i++) sum += +chars[i] * (10 - i);

    remainder = sum % 11;
    lastDigit = remainder < 2 ? remainder : 11 - remainder;

    return +chars[9] === lastDigit;
};

window.LogOut = function () {
    let h = new Helper();
   
    h.Ajax('Home', 'LogOut', {},
        function (data) {
            
            localStorage.clear();
            document.cookie = "jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            window.goToLink('LoginLink');
            window.menu = null;
            window.menu2 = null;
            window.menuMen = null;

        }, function () {
            h.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
        }
    )


}
window.PreLoadForms = new Array();

  class Helper {
    constructor() {
        this.errors = [];
        this.Elements = [];
        this.ChangeColor = this.ChangeColor.bind(this);
        this.Ajax = this.Ajax.bind(this);
        this.SetDataBack = this.SetDataBack.bind(this);
        this.CheckTime = this.CheckTime.bind(this);
        this.Select2AjaxSelectOption = this.Select2AjaxSelectOption.bind(this);
        this.LoadState = this.LoadState.bind(this);
        this.AjaxSubmit = this.AjaxSubmit.bind(this);
      }


      // اشتراک‌گذاری متن در موبایل (Android/iOS) با Web Share API
async   shareText(text, title = 'اشتراک‌گذاری', url = '') {
  if (!text) throw new Error('متن خالی است');

  if (navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url: url || undefined,
      });
      return true; // موفق
    } catch (err) {
      // کاربر Cancel زده یا خطا رخ داده
      console.warn('Share canceled/failed:', err);
      return false;
    }
  }

  // fallback برای مرورگرهایی که پشتیبانی نمی‌کنند: کپی در کلیپ‌بورد
  try {
    await navigator.clipboard.writeText(text + (url ? `\n${url}` : ''));
    alert('مرورگر شما Share را پشتیبانی نمی‌کند؛ متن کپی شد.');
    return true;
  } catch (e) {
    // fallback نهایی
    const ta = document.createElement('textarea');
    ta.value = text + (url ? `\n${url}` : '');
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
    alert('متن کپی شد.');
    return true;
  }
}



      fnExcelReport(ele) {
          $('table select').hide();
    let tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
           let j = 0;
           let tab = ele // id of table

    for (j = 0; j < tab.rows.length; j++) {
        tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
        //tab_text=tab_text+"</tr>";
    }

    tab_text = tab_text + "</table>";
    tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
    tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
    tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

           let msie = window.navigator.userAgent.indexOf("MSIE ");

    // If Internet Explorer
 
        // other browser not tested on IE 11
           let sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent("\ufeff"+tab_text));
    
          $('table select').show();
    return sa;
}


      viewFile(url,filename) {
          let token = localStorage.getItem('token');
          console.log(url);
          // Change this to use your HTTP client
          fetch(url, { headers: { Authorization: 'Bearer ' + token } }) // FETCH BLOB FROM IT
              .then((response) => response.blob())
              .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
                  var _url = window.URL.createObjectURL(blob);
                  let a = document.createElement('a');
                  a.download = filename;
                  a.href = _url;
                  a.target = "_blank";
                  document.body.append(a);
                  
                 
                  a.click();
                  document.body.removeChild(a);

                  // window.open + focus
              }).catch((err) => {
                  console.log(err);
              });
      }
      async  viewFileText(url, filename) {
    try {
        const token = localStorage.getItem('token');

        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if (!response.ok) throw new Error("Network error");

        const text = await response.text();

        const blob = new Blob([text], {
            type: "text/plain;charset=utf-8;"
        });

        const objectUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(objectUrl);
    } catch (err) {
        console.error(err);
    }
}
        download(context, filename) {
          try {
         

              const blob = new Blob([context], {
                  type: "text/plain;charset=utf-8;"
              });

              const objectUrl = URL.createObjectURL(blob);

              const a = document.createElement("a");
              a.href = objectUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();

              URL.revokeObjectURL(objectUrl);
          } catch (err) {
              console.error(err);
          }
      }

      SaveState() {

          let url = window.location.href;
          let state = new Array();
          $('input[id]').each((index, obj) => {

              let id = $(obj).attr('id');
              if (id.startsWith('txt') == false) {
                  return;
              }
              state.push({ 'typ': 'Text', 'id': $(obj).attr('id'), 'value': $(obj).val() });
          });
          $('select[id]').each((index, obj) => {
              let id = $(obj).attr('id');
              if (id.startsWith('txt') == false) {
                  return;
              }
              state.push({ 'typ': 'Select', 'id': $(obj).attr('id'), 'value': $(obj).val() });
          });
          window.PreLoadForms[url] = state;
      }

      LoadState() {
          let url = window.location.href;
          let datas = window.PreLoadForms[url];
          let cmd = this;

          if (datas == undefined) {
              return false;
          }
          for (let i = 0; i < datas.length; i++) {
              let cVal = datas[i];
              if (cVal.id.startsWith('txt') == false) {
                  continue;
              }

              if (cVal.typ == 'Text') {
                  $('#' + cVal.id).val(cVal.value);
              }
              if (cVal.typ == 'Select') {
                  let o = document.getElementById(cVal.id);
                  if (o.getAttribute('source') == undefined) {
                      this.Select2AjaxSelectOption(cVal.value, o, this);
                  }
                  else {
                      $(o).val(cVal.value).trigger('change');
                  }
              }
          }
          $('[serachbtn="yes"]').click();
          return true;

      }

    GetRecordWithCircita(arr, columnName, value) {
        let r = new Array();

        for (let i = 0; i < arr.length; i++) {

            if (arr[i][columnName] == value) {
                r.push(arr[i]);
            }
        }
        return r;

    }


    CheckEmail(ele,Caption) {
        let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let b = ele.value.match(validRegex);
        if (b == null) {

            b = false;
        }
        this.ChangeColor(b, ele, 'پست الکترونیک در ' + Caption  +' صحیح نیست')
        return b;
    }
    addColumnToData(arr, name, defaultValue) {
        for (let i = 0; i < arr.length; i++) {
            arr[i][name] = defaultValue;
        }
    }
      addCommas(nStr) {
          if (nStr == undefined) {
              return "-";
          }
          nStr += '';
          let x = nStr.split('.');
          let x1 = x[0];
          let x2 = x.length > 1 ? '.' + x[1] : '';
          let rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }
          return x1 + x2;
      }


    GetDataGrouped(data) {
        let DataList = new Array();
        DataList[RowState.NoChanged] = new Array();
        DataList[RowState.Inserted] = new Array();
        DataList[RowState.Changed] = new Array();
        DataList[RowState.Deleted] = new Array();
        for (let k = 0; k < data.length; k++) {
            let rowstate = data[k].rowState;
            if (rowstate == undefined) {
                rowstate = RowState.NoChanged;
            }
            DataList[rowstate].push(data[k])
        }

        return DataList;
    }
      GetDataGroupedByKey(data,name) {
          let DataList = new Array();
        
          for (let k = 0; k < data.length; k++) {
              let val = data[k][name];
              if (DataList[val] === undefined) {
                  DataList[val] = new Array();
                  DataList[val].push(data[k]);
              }
              else {
                  DataList[val].push(data[k]);
              }
          }

          return DataList;
      }
      GetNonRepeatData(data, name) {
          let DataList = new Array();

          for (let k = 0; k < data.length; k++) {
              let val = data[k][name];
              if (DataList[val] === undefined) {
                  DataList[val] = new Array();
                //  DataList[val].push(data[k]);
              }
              else {
               //   DataList[val].push(data[k]);
              }
          }

          return Object.keys( DataList);
      }

    ChangeColor(cond, ele, Message) {
        if (cond == false) {
           let rownum = ele.attributes['rownum'];
            if (rownum != undefined) {
                Message = 'ردیف شماره ' + rownum.value + ":" + Message;

            }
            this.errors.push(Message);
            $(ele).removeClass('is-valid');
            $(ele).addClass('is-invalid');
            this.Elements.push(ele);
        }
        else {
            $(ele).removeClass('is-invalid');
            $(ele).addClass('is-valid');
            
        }

    }
    Redirect(controller, action) {


    }
      NormalaizeSelect2() {
          $('table .select2').each(function (index, obj) {
              $(obj).css('width', '');
              $(obj).css('padding', '0');
              $(obj).addClass('form-control');
          });
          $('table .selection').each(function (index, obj) {
              $(obj).css('padding', '0px !important');
          });
      }
      AjaxSubmit(controller, action,id) {
          let cmd = this;
          cmd.Validate();
          if (cmd.isValidate() == false) {
              return;
          }

          let data = cmd.GetPostData();
          cmd.Ajax(controller, action, {Model:data,id:id}, function (data) {
              if (data.status == '200') {
                  cmd.MessageBox(data.message);
                  cmd.GoBack();
              }
              else {
                  cmd.Error(data.message);
              }
          });
      }


  Ajax(controller, action, data, funcOk, funcFail,showMessage=true) {
      let thisCmd = this;
      $('#AjaxStatus').show();
      let token = localStorage.getItem('token');
      let key = controller + "/" + action + "/" + JSON.stringify(data);


      if (window.ajaxAnitRepeat.indexOf(key) != -1) {
     
          return;
      }

      window.ajaxAnitRepeat.push(key)
    

      $.ajax('/' + controller + "/" + action 
          , {
              method: 'POST', dataType: "json", headers: (token == null ? {} : {
                  Authorization: 'Bearer ' + token
              }), data: data, success: function (data) {
                  const index = window.ajaxAnitRepeat.indexOf(key);

                  if (index !== -1) {
                      window.ajaxAnitRepeat.splice(index, 1);
                  }
                  $('#AjaxStatus').hide(); funcOk(data);
              }
              , error: function (err) {
                
                  const index = window.ajaxAnitRepeat.indexOf(key);

                  if (index !== -1) {
                      window.ajaxAnitRepeat.splice(index, 1);
                  }


                  $('#AjaxStatus').hide();
                  if (showMessage) {
                      if (err.status == 401) {
                          let ic = 0;
                         
                       
                              thisCmd.Error(FixedMessage.NeedLogin, FixedMessage.Result);
                          window.goToLink('LoginLink');
                          
                          window.menu = null;
                          window.menu2 = null;
                      }
                      else if (err.status == 500)
                      {
                          try {
                              let datap = parseJSON(err.responseText);

                              if (datap.message != undefined) {
                                  thisCmd.MessageBox(FixedMessage.ErrorRaise + ':' + datap.message, FixedMessage.Result);
                              }
                              else {
                                  thisCmd.MessageBox(FixedMessage.ErrorRaise + ':' + err.responseText, FixedMessage.Result);

                              }
                          }
                          catch {

                          }
                       
                          funcFail(err);
                      }
                      else if (err.status == 403) {
                          thisCmd.MessageBox(FixedMessage.NotPermited, FixedMessage.Result);
                          thisCmd.GoBack();
                      }
                      else if (err.status == 404) {
                          thisCmd.MessageBox(FixedMessage.Err404, FixedMessage.Result);
                      }
                      else {
                          console.error(err);
                      }
                  }
                else {
                    funcFail(err);
                }
            }


    } );
 

    }

      AjaxForUpload(controller, action, data, funcOk, funcFail, showMessage = true) {

          let thisCmd = this;
          $('#AjaxStatus').show();

          $('.Progr').show();
          let token = localStorage.getItem('token');
          $.ajax('/' + controller + "/" + action
              , {
                  type: 'POST', dataType: "json", headers: (token == null ? {} : {
                      Authorization: 'Bearer ' + token
                  }), data: data,

                  xhr: function () {
                      let xhr = new XMLHttpRequest();
                      if (xhr.upload) {
                          xhr.upload.onprogress = function (e) {
                              if (e.lengthComputable) {
                                  let pos = e.loaded || e.position;
                                  console.log(pos / e.total * 100);
                                  let per = (pos / e.total) * 100;
                                  $('.progress-bar').html(per + '%');
                                  $('.progress-bar').css('width', per + '%');
                                  $('.progress-bar').attr('aria-valuenow', per);

                              }
                          };
                      }
                      return xhr;
                  }

                  , processData: false, contentType: false, success: function (data) { $('.Progr').hide(); $('#AjaxStatus').hide(); funcOk(data); }
                  , error: function (err) {
                      $('.Progr').hide();
                      $('#AjaxStatus').hide();
                      if (showMessage) {
                          if (err.status == 401) {
                              thisCmd.MessageBox(FixedMessage.NeedLogin, FixedMessage.Result);
                              setTimeout(
                                  function
                                      () {
                                      window.reload();
                                  }, 3000
                              );
                          }
                          else if (err.status == 500) {
                              let datap = parseJSON(err.responseText);
                              if (datap.message != undefined) {
                                  thisCmd.MessageBox(FixedMessage.ErrorRaise + ':' + datap.message, FixedMessage.Result);
                              }
                              else {
                                  thisCmd.MessageBox(FixedMessage.ErrorRaise + ':' + err.responseText, FixedMessage.Result);

                              }
                              funcFail(err);
                          }
                          else if (err.status == 403) {
                              thisCmd.MessageBox(FixedMessage.NotPermited, FixedMessage.Result);
                              thisCmd.GoBack();
                          }
                          else if (err.status == 404) {
                              thisCmd.MessageBox(FixedMessage.Err404, FixedMessage.Result);
                          }
                          else {
                              funcFail(err);
                          }
                      }
                      else {
                          funcFail(err);
                      }
                  }


              });


      }

      isTimeValid(str) {
          if (str.length != 5) {
              return "فرمت ساعت بایستی به صورت 00:00 باشد"
          }
          let p = str.split(':');
          if (p.length != 2) {
              return "فرمت ساعت بایستی به صورت 00:00 باشد"
          }
          let h = parseInt(p[0]);
          let m = parseInt(p[1]);
          if (isNaN(h) || isNaN(m)) {
              return "عدد واردشده نادرست می باشد";
          }

          if (h < 1 || h > 24) {
              return "ساعت بایستی بین 1 الی 24 باشد";
          }
          if (m < 0 || h > 59) {
              return "دقیقه بایستی بین0 الی 59 باشد";
          }
          return "";
      }
     
      GoBack() {
         
          
          window.history.back();
       
          setTimeout(function () {
          
              if (document.getElementById('root').innerHTML == "") {
                  window.reload();
              }
              let h = new Helper();
              h.LoadState();
          }, 1000);
      }
      GetNumber(v) {
          return parseInt(v.toString().replace(/,/g, ''));

      }


    GetPostData() {


        let Model = new Object();
        $('form [model]').each(function (index, obj) {
            let cType = $(obj).attr('customHelper');

            Model[$(obj).attr('model')] =
                $(obj).val();

            if (cType == CustomHelper.isDigitngGroupedNumber) {
                Model[$(obj).attr('model')] =
                    parseInt($(obj).val().replace(/,/g, ''));



            }
            if (cType == CustomHelper.File) {
                Model[$(obj).attr('model')] = obj.value;
                     



            }
            if (cType == CustomHelper.Html) {
                Model[$(obj).attr('model')] = window.tinymce.editors[obj.id].contentDocument.body.innerHTML;




            }
            if (cType == CustomHelper.isDate) {

                let valu = $(obj).val();
                let parts = valu.split('/');
                let va = toGregorian(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]));
                if (valu == '') {
                    Model[$(obj).attr('model')] = '';
                }
                else {
                    Model[$(obj).attr('model')] = va.gy + '/' + va.gm + '/' + va.gd;
                }
               
                 



            }

        });

        return Model;

      }
      perToMil(v) {
          let parts = v.split('/');
          let va = toGregorian(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]));
          return va.gy + "/" + va.gm + "/" + va.gd;
      }
      MilToPer(value) {
       
          let jToday = toJalaali(value.getFullYear(), value.getMonth() + 1, value.getDate());
          return jToday.jy + "/" + this.NormalLength(jToday.jm, 2) + "/" + this.NormalLength(jToday.jd,2);
      }
      NormalLength(v, len) {
          v = v.toString();
          while (v.length < len) {
              v = "0" + v;
          }
          return v;
      }
      SetDataBack(dat) {
          let cmd = this;
        $('[initvalue]').each(function (index, ele) {
            let value = dat[ele.attributes['initvalue'].value ];
            $(ele).val(value);
            if ($(ele).attr('customHelper') == CustomHelper.isDigitngGroupedNumber) {
                $(ele).val(cmd.addCommas(value));
            }
            if ($(ele).attr('customHelper') == CustomHelper.Image) {
                $('#' +ele.id.replace('txt','img')).attr('src',value);
            }
            if ($(ele).attr('htmlEditor') == 'yes') {
                setTimeout(() => { window.tinymce.editors[ele.id].setContent(value) }, 500);
            
 
            }
            if (ele.tagName == "SELECT") {
                if (ele.attributes['source'] == undefined) {


                    cmd.Select2AjaxSelectOption(value, ele, cmd);

                }
                else {
                    $(ele).val(value).trigger('change');
                }
            }

        });


    }
      Sum(array, prop) {
          let sumValue = 0;
          for (let i = 0; i < array.length; i++) {
              let v = parseInt(array[i][prop]);
              if (isNaN(v)==false) {
                  sumValue += v;
              }
          }
          return sumValue;
      }



      Select2AjaxSelectOption(value, ele, cmd) {
          let data = {
              id: value, entity: ele.attributes['entity'].value
          };
          data = data;
          cmd.Ajax('Home', 'PutBackValueInSelect2', data,
              function(data) {
                  let r = data.results[0];
                  let o = new Option(r.text, r.id, false, false);

                  
                  $(ele).append(o).val(o.value).trigger('change');
                  
              }, function() { }
          );
      }

      Select2AjaxSelectOptionMlut(arr,idColumn,titleColumn , ele) {
       
  
          for (let i = 0; i < arr.length; i++) {
              let o = new Option(arr[i][titleColumn], arr[i][idColumn], true, true);
              $(ele).append(o) 
          }

              


       
            $(ele).trigger('change');
 
      }


    isValidate() {
        let err = this.errors;
        if (err.length == 0) {
            return true;
        }
        else {
           let message = "";
            for (let i = 0; i < err.length; i++) {
                message += err[i] + "<br />";
            }
            this.Error(message);
            return false;
        }

      }


      CheckTime(ele, Caption) {


          let val = $(ele).val();
          let m = this.isTimeValid(val)
          this.ChangeColor(m == "", ele, m);

      }
    CheckDate(ele, Caption) {


        let val = $(ele).val();
        if (val.trim() == "") {
            this.ChangeColor(false, ele, 'کادر  ' + Caption + ' نبایستی خالی باشد ');
            return false;
        }
        


        let parts = val.split('/');
        if (parts.length != 3) {
            this.ChangeColor(false, ele, 'کادر  ' + Caption + ' دارای فرمت نادرست می باشد فرمت صحیح YYYY/MM/DD می باشد ');
            return false;
        }
        let maxValue = [1500, 12,31];
        for (let i = 0; i < parts.length; i++) {
            let cvalue = parseInt(parts[i]);
            if (isNaN(cvalue)) {
                this.ChangeColor(false, ele, 'کادر  ' + Caption + ' دارای فرمت نادرست می باشد فرمت صحیح YYYY/MM/DD می باشد ');

                return false;
            }
            if (i == 1) {
                maxValue[2] = (cvalue > 6 ? 30 : 31);
            }
            if (cvalue > maxValue[i]) {
                this.ChangeColor(false, ele, 'کادر  ' + Caption + ' عدد ' + cvalue + ' صحیح نمی باشد ');
                return false;
            }

        }


        this.ChangeColor(true, ele, 'کادر  ' + Caption + ' دارای فرمت نادرست می باشد فرمت صحیح YYYY/MM/DD می باشد ');
        return true;
      }

      CheckNumber(ele, Caption) {
          let val = $(ele).val();

          if (val.trim() == "") {
              this.ChangeColor(false, ele, 'کادر ' + Caption + ' نباید خالی نمی باشد ');
              return false;
          }
          val = val.replace(/,/g, '');
          let valMax = parseInt(val);
          if (isNaN(valMax)) {
              this.ChangeColor(false, ele, 'عدد وارده شده در کادر  ' + Caption + ' صحیح نمی باشد ');
              return false;
          }
          this.ChangeColor(true, ele, 'عدد وارده شده در کادر  ' + Caption + ' صحیح نمی باشد ');

      }
    CheckEmpty(ele,Caption) {
        let Message = 'کادر  ' + Caption + ' نبایستی خالی باشد ';
        let cu = $(ele).attr('customHelper');
        if (cu == CustomHelper.isDate) {

           return this.CheckDate(ele, Caption);
            
        }
        if (cu == CustomHelper.timeMode) {

            return this.CheckTime(ele, Caption);

        }
        if (cu == CustomHelper.isDigitngGroupedNumber) {

           return this.CheckNumber(ele, Caption);
           
        }
        let val = ele.value;
        this.ChangeColor($(ele).val() != '' && val!='', ele, Message);
        return $(ele).val() != '';
    }
    CheckMobile(ele, caption) {
        let valueele = $(ele).val();
        if (valueele != "") {
            let Message = ' شماره موبایل وارده در  ' + caption + ' صحیح نیست  ';
            let result = ((valueele.length == 11) && (valueele.startsWith("09")));
            this.ChangeColor(result, ele, Message);
            return result;
        }

      }

      CheckNatCode(ele, caption) {
          let valueele = $(ele).val();
          if (valueele != "") {
              let Message = 'شماره ملی وارده شده صحیح نیست';
              let result = ((valueele.length == 10) && (isValidNationalCode(valueele)));
              this.ChangeColor(result, ele, Message);
              return result;
          }

      }


      CheckMinValue(ele, caption) {
          let valueele = $(ele).val();
          let v = parseInt(valueele);
          let min = parseInt(ele.attributes['minvalue'].value);
          let message = 'عدد وارده در ' + caption + ' نبایستی از  ' + min + ' کمتر باشد ';
          this.ChangeColor(v >= min, ele, message);
      }
      CheckMaxValue(ele, caption) {
          let valueele = $(ele).val();
          let v = parseInt(valueele);
          let max = parseInt(ele.attributes['maxvalue'].value);
          let message = 'عدد وارده در ' + caption + ' نبایستی از  ' + max + ' بیشتر باشد ';
          this.ChangeColor(v <= max, ele, message);
      }


    CheckMinLength(ele, caption, length) {
        let l = parseInt(length);
        let Message = ' طول حروف نبایستی کادر ' + caption + ' از  ' + length + ' حرف کمتر باشد';
        this.ChangeColor(($(ele).val().length >= l),ele, Message)
        return $(ele).val().length >= l;
      }
      ValidateForItem(id) {
          let thisCls = this;
          $('#'+id + '[mustfill]').each(function (index, ele) {
              thisCls.CheckEmpty(ele, $(ele).attr('caption'));
          });
          $('#' + id +'[isemail]').each(function (index, ele) {
              thisCls.CheckEmail(ele, ele.attributes['caption'].value);
          });
          $('#' + id +'[mobile]').each(function (index, ele) {
              thisCls.CheckMobile(ele, ele.attributes['caption'].value);
          });
          $('#' + id + '[minlength]').each(function (index, ele) {
              thisCls.CheckMinLength(ele, ele.attributes['caption'].value, parseInt( ele.attributes['minlength'].value));
          });
    
          $('#' + id +  '[natcode]').each(function (index, ele) {

              thisCls.CheckNatCode(ele, '');
          });
          $('#' + id +'[equalvalue]').each(function (index, ele) {
              let parrentelement = $('#txt' + ele.attributes['equalvalue'].value);
              if ($(ele).val() != parrentelement.val()) {
                  thisCls.errors.push(' عیارت  ' + (ele).attributes['caption'].value + ' با عبارت  ' + parrentelement[0].attributes['caption'].value + ' یکسان نیست  ');

              }
          });
          $('#' + id + '[minvalue]').each(function (index, ele) {
              thisCls.CheckMinValue(ele, ele.attributes['caption'].value);
          });
          $('#' + id + '[maxValue]').each(function (index, ele) {
              thisCls.CheckMaxValue(ele, ele.attributes['caption'].value);
          });
          return thisCls.errors;
      }


    Validate() {
        let thisCls = this;
        $('[htmleditor]').each((index, ele) => {
            ele.innerHTML = window.tinymce.editors[ele.id].contentDocument.body.innerHTML;

        })


        $('[mustfill]').each(function (index, ele) {
            thisCls.CheckEmpty(ele, $(ele).attr('caption'));
        });
        
        $('[isemail]').each(function (index, ele) {
            thisCls.CheckEmail(ele, ele.attributes['caption'].value);
        });
        $('[mobile]').each(function (index, ele) {
            thisCls.CheckMobile(ele, ele.attributes['caption'].value);
        });
        $('[minlength]').each(function (index, ele) {
            thisCls.CheckMinLength(ele, ele.attributes['caption'].value, ele.attributes['minlength'].value);
        });
        $('[natcode]').each(function (index, ele) {

            thisCls.CheckNatCode(ele, '');
        });

        $('[equalvalue]').each(function (index, ele) {
            let parrentelement = $('#txt' + ele.attributes['equalvalue'].value);
            if ($(ele).val() != parrentelement.val()) {
                thisCls.errors.push(' عیارت  ' + (ele).attributes['caption'].value + ' با عبارت  ' + parrentelement[0].attributes['caption'].value + ' یکسان نیست  ');

            }
        });
        $('[minValue]').each(function (index, ele) {
            thisCls.CheckMinValue(ele, ele.attributes['caption'].value);
        });
        $('[maxValue]').each(function (index, ele) {
            thisCls.CheckMaxValue(ele, ele.attributes['caption'].value);
        });
        for (let i = 0; i < this.Elements.length; i++) {
            $(this.Elements[i]).removeClass('is-valid');
            $(this.Elements[i]).addClass('is-invalid');

            
          
        }
      }
      Alert(Message) {
          $('#messageText').html(Message);
          $('.messageBox').removeClass('alert-primary');
          $('.messageBox').removeClass('alert-danger');
          $('.messageBox').addClass('alert-primary');
          $('.messageBox').fadeIn("0.5s");
        
          setTimeout(() => { $('.messageBox').fadeOut("0.5s"); }, 5000);
      }
      Error(Message) {
          $('#messageText').html(Message);
          $('.messageBox').removeClass('alert-primary');
          $('.messageBox').removeClass('alert-danger');
          $('.messageBox').addClass('alert-danger');
          $('.messageBox').fadeIn("0.5s");

          setTimeout(() => { $('.messageBox').fadeOut("0.5s"); }, 15000);
      }

      MessageBox(Message, title) {
        
              $('#modal_title').html(title);
              $('#modal_body').html(Message);
              $('#myModal').modal('show');
          
      


    }
      ConfirmAction(Message = 'آیا مطممن هستید', title = "آیا مطممن هستید", funcOk, funcNo = () => { }) {
        $('#conmodal_title').html(title);
        $('#conmodal_body').html(Message);
        $('#conmyModal').modal('show');
        window.confimFun = funcOk;
        window.noFun = funcNo;
    }
      PutDataInObjet(obj, prop, rprop, oprop, newValue) {
          if (obj[prop] != undefined) {
              rprop[oprop] = newValue;
          }
      }
      PutDataInObjetCopy(obj, prop, rprop   ) {
          if (obj[prop] != undefined) {
              rprop[prop] = obj[prop] ;
          }
      }

      createPivot(arr, groupByTitle, PovitKeyName, PovitKeyValue) {
    const result = {};
    const allPivotKeys = new Set(); // برای ذخیره سرستون‌ها

    arr.forEach(item => {
        const groupKey = groupByTitle.map(key => item[key]).join('|');

        if (!result[groupKey]) {
            result[groupKey] = { group: {}, total: 0, count: 0 };
            groupByTitle.forEach(key => {
                result[groupKey][key] = item[key];
            });
        }

        const pivotName = item[PovitKeyName];
        const pivotValue = item[PovitKeyValue];

        // اضافه کردن مقدار Pivot
        result[groupKey].group[pivotName] =
            (result[groupKey].group[pivotName] || 0) + pivotValue;

        // ذخیره سرستون‌ها
        allPivotKeys.add(pivotName);

        // خروجی‌های اضافه
        result[groupKey].total += pivotValue;
        result[groupKey].count += 1;
    });

    return {
        data: Object.values(result),       // خروجی اصلی Pivot
        columns: Array.from(allPivotKeys)  // آرایه‌ی سرستون‌ها
    };
}




      jsonNameFix(val: String) {
          return val[0].toLowerCase() + val.substring(1, val.length );
      }
    FliterArray(obj, fliterValue) {
        let keys = Object.keys(obj);
        fliterValue = fliterValue.toLowerCase();
        for (let x = 0; x < keys.length; x++) {
            if (obj[keys[x]] == null) {
                continue;
            }
            if (obj[keys[x]].toString().toLowerCase().indexOf(fliterValue)!=-1) {
                console.log('found');
                return true;
            }

            
        }
        console.log('found not');
        return false;
      }

      GetCaptionFromEnum(Enum: Array, Value: String) {
           
          for (let i = 0; i < Enum.length; i++) {
              if (Enum[i].value == Value) {
                  return Enum[i].caption;
              }
          }

          return 'مقدار یافت نشد!!!!';
      }

      ShowMap(location, callBack) {
          var z = window.open('/Home/SelectMap?loc=' + location);

          setTimeout(() => { z.window.callback = callBack });
      }

      numberToPersianWords(num) {
          if (num === 0) return "صفر";

          const yekan = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
          const dahgan = ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
          const sadgan = ["", "صد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
          const dahYekan = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];

          function threeDigitsToWords(n) {
              let str = "";
              let s = Math.floor(n / 100);
              let d = Math.floor((n % 100) / 10);
              let y = n % 10;

              if (s > 0) str += sadgan[s];

              if (d > 1) {
                  if (str) str += " و ";
                  str += dahgan[d];
                  if (y > 0) str += " و " + yekan[y];
              } else if (d === 1) {
                  if (str) str += " و ";
                  str += dahYekan[y];
              } else if (y > 0) {
                  if (str) str += " و ";
                  str += yekan[y];
              }

              return str;
          }

          const parts = [];
          const units = ["", "هزار", "میلیون", "میلیارد"];
          let i = 0;

          while (num > 0) {
              let chunk = num % 1000;
              if (chunk > 0) {
                  let chunkWords = threeDigitsToWords(chunk);
                  if (units[i]) chunkWords += " " + units[i];
                  parts.unshift(chunkWords);
              }
              num = Math.floor(num / 1000);
              i++;
          }

          return parts.join(" و ");
      }





}


export   { Helper }